/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Modal } from 'react-bootstrap-v5'
import { ImportRequestDetailModel } from '../../../../models/ImportRequestModel'

type Props = {
    show: boolean
    mode: string
    data?: ImportRequestDetailModel[]
    qrReqData?: {name: string, url: string, nums: number}[]
    onClose: () => void
    handleSetExportData: (index: number, name: string, url: string, nums: number, id: number|string) => void 
    handleExport: (isPrinter?: boolean) => void
    handlePrintQr: () => void
    handleCheck: (index: number, name: string, url: string, checked: boolean,  id: number|string) => void
}

const ExportQrModal: React.FC<Props> = ({ qrReqData, show, data, onClose, handleSetExportData, handleExport, handleCheck, handlePrintQr}) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Tùy chọn xuất QR Code</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
            <form>
                <div className="row mb-2">
                    <div className='col-1'></div>
                    <div className='col-7'><b>Sản phẩm</b></div>
                    <div className='col-4'><b>Số lượng</b></div>
                </div>
                {data && data.map((item: ImportRequestDetailModel, index: number) => {
                    let url = `${window.location.origin}/add-to-cart/${item.product?.inventory_of_sento_id}`;
                    let checked = false;
                    let reqNum = 1;
                    let findedItem = qrReqData?.find((e) => e.url == url);
                    if (findedItem) {
                        checked = findedItem.nums > 0 ? true : false;
                        reqNum = findedItem.nums;
                    }
                    let pdName = item.product?.inventory_of_sento?.name ?? '';
                    return (
                        <div className="row mt-3">
                            <div className='col-1'><input checked={checked} type='checkbox' onChange={(e: any) => handleCheck(index, pdName, url, e.target.checked, item.product?.inventory_of_sento_id ?? 0 )} /></div>
                            <div className='col-7'>{pdName}</div>
                            <div className='col-4'><input value={reqNum} onChange={(e: any) => handleSetExportData(index, pdName, url, e.target.value, item.product?.inventory_of_sento_id ?? 0)} type='number' className='form-control'/></div>
                        </div>
                    )
                })}
                <div className='d-flex mb-4 justify-content-center pt-8'>
                    <button className="btn btn-bg-primary me-2" type="button" onClick={() => handleExport()}>Tải file PDF</button>
                    <button className="btn btn-bg-primary me-2" type="button" onClick={() => handleExport(true)}>In tem</button>
                    <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Tắt</button>
                </div>
            </form>
            </Modal.Body>
        </Modal>
    )
}

export default ExportQrModal
